import { Add, Remove } from '@mui/icons-material';
import { Box, Button, InputProps, SxProps, TextField, styled } from '@mui/material';
import classnames from 'classnames';

const QuantityBox = styled(Box)<{ issmall?: string }>`
  width: ${({ issmall }) => (issmall ? 'auto' : '150px')};
  ${({ issmall }) => issmall && 'height: 36px;'}
  position: relative;
  display: flex;
  align-items: center;
  background-color: #fff;
  border-radius: 4px;
  input {
    outline: none;
    font-weight: 700;
    font-size: 16px;
    line-height: 24px;
    color: #000000;
    text-align: center;
    width: 40px;
    ${({ issmall }) => issmall && 'height: 36px;'}
    padding: ${({ issmall }) => issmall && '0;'};
  }
  fieldset {
    border: 0 !important;
    border-radius: 0;
  }

  .MuiInputBase-root {
    ${({ issmall }) => issmall && 'height: 36px;'}
    background-color: transparent;
  }
  &.dark {
    background: #e2e9ea;
  }

  .quantity-button {
    border: 0 !important;
    outline: 0;
    width: 24px;
    padding: 0;
    height: 44px;
    &.increase {
      border-bottom-left-radius: 0px;
      border-top-left-radius: 0px;
      border-bottom-right-radius: 4px;
      border-top-right-radius: 4px;
    }
    &.decrease {
      border-bottom-right-radius: 0px;
      border-top-right-radius: 0px;
      border-bottom-left-radius: 4px;
      border-top-left-radius: 4px;
    }
  }
`;

const QuantityButton = styled(Button)<{ issmall?: string }>`
  min-width: 0;
  background: transparent;
  min-width: auto !important;

  padding: 8px 24px !important;
  ${({ issmall }) => issmall && 'padding: 16px !important;'}
`;

export type QuantitySelectorProps = {
  dark?: boolean;
  maxQuantity?: number;
  quantity: number;
  setQuantity: (quantity: number) => void;
  size?: InputProps['size'];
  sx?: SxProps;
};

export const QuantitySelector = ({
  dark,
  maxQuantity = 999,
  quantity,
  setQuantity,
  size,
}: QuantitySelectorProps) => {
  const isSmall = size === 'small' ? 'true' : undefined;

  // Increase / decrease
  const increaseQuantity = () => setQuantity(Math.min(quantity + 1, maxQuantity));
  const decreaseQuantity = () => setQuantity(Math.max(1, quantity - 1));

  // Handle text field changes
  const changeQuantity = (e: React.ChangeEvent<HTMLInputElement>) => {
    try {
      const parsedQuantity = parseInt(e.target.value);
      if (parsedQuantity > 0) {
        setQuantity(Math.min(parsedQuantity, maxQuantity));
      }
    } catch {
      setQuantity(1);
    }
  };

  return (
    <QuantityBox className={classnames({ dark: dark }, 'quantity-box')} issmall={isSmall}>
      <QuantityButton
        variant='ghost'
        onClick={decreaseQuantity}
        className='quantity-button decrease'
        size={size}
        issmall={isSmall}
      >
        <Remove />
      </QuantityButton>
      <TextField
        value={quantity}
        sx={{ textAlign: 'center' }}
        className='quantity input'
        onChange={changeQuantity}
        size={size}
      />
      <QuantityButton
        variant='ghost'
        onClick={increaseQuantity}
        className='quantity-button increase'
        size={size}
        issmall={isSmall}
      >
        <Add />
      </QuantityButton>
    </QuantityBox>
  );
};
